var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24.2974C18.6274 24.2974 24 18.9248 24 12.2974C24 5.66995 18.6274 0.297363 12 0.297363C5.37258 0.297363 0 5.66995 0 12.2974C0 18.9248 5.37258 24.2974 12 24.2974ZM17.7311 8.97968L16.2689 7.61505L9.9752 14.3583L7.70711 12.0903L6.29289 13.5045L10.0248 17.2364L17.7311 8.97968Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFilled);
export default __webpack_public_path__ + "static/media/check-filled.762218a3b6f6ff98601c8eac7e5b5ceb.svg";
export { ForwardRef as ReactComponent };